import { analytics } from '../analytics';
import { FILE_UPLOAD_EVENT_IDS } from '../events';
import { generateRandomIPAddress } from '../utils';

interface TrackOprReportSubmittedProps {
  organisation_id?: string;
  report_id: string;
  total_file_size: number;
  total_file_count: number;
  successful_file_count: number;
  failed_file_count: number;
  file_types: string[];
  category: string;
  relationship_to_company: number | null;
  is_anonymous: boolean;
}

interface TrackOprReportSentProps {
  organisation_id?: string;
  report_id: string;
  total_file_size: number;
  unique_file_types: string[];
  total_file_count: number;
  category: string;
  relationship_to_company: number | null;
  is_anonymous: boolean;
}

export const trackOprReportSubmitted = (
  properties: TrackOprReportSubmittedProps,
) => {
  return analytics.track(
    FILE_UPLOAD_EVENT_IDS.OPR_REPORT_SUBMITTED,
    properties,
    { context: { ip: generateRandomIPAddress() } },
  );
};

export const trackOprReportSent = (properties: TrackOprReportSentProps) => {
  return analytics.track(FILE_UPLOAD_EVENT_IDS.OPR_REPORT_SENT, properties, {
    context: { ip: generateRandomIPAddress() },
  });
};
